import { TextBox } from '@apply/components';
import { useCustomPaymentAddressStreet1 } from '../../../../../fields/CustomPaymentFields';

interface StreetAddress1Props {
    customPaymentId: string;
    required?: boolean;
    validator?: React.ReactNode;
}

export const StreetAddress1: React.FC<StreetAddress1Props> = ({ customPaymentId, required = false, validator }) => {
    const label = 'Street Address';
    const [streetAddress1, set_streetAddress1] = useCustomPaymentAddressStreet1(customPaymentId);
    return (
        <>
            <TextBox
                id='streetAddress1'
                value={streetAddress1}
                onChange={(value) => set_streetAddress1(value)}
                label={label}
                placeholder='123 Main Street'
                required={required}
                width='100%'
                maxLength={50}
                validator={validator}
            />
        </>
    );
};
